module.exports = __webpack_public_path__ + "static/media/iStock-638610308.03b2430a.jpg";